import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import Slide from '@mui/material/Slide';
import { Container, Grid, useMediaQuery, useTheme } from '@mui/material';
import OTPInput from 'react18-otp-input';
import { useSelector, useDispatch } from 'react-redux';
import {
  closeOtpModal,
  getMessageOtp,
  goToNextStep,
} from '../../../redux/creates-action/OtpAction';
import { verifyOtp } from '../../../services/Login';
import { resetPasswordGraphql } from '../../../services/ForgotPassword';
import {
  openLoadingApi,
  closeLoadingApi,
} from '../../../redux/creates-action/LoadingAction';
import { createAllMerchant, verifyOtpSignUp } from '../../../services/SignUp';
import {
  finalStep,
  signUpSuccess,
} from '../../../redux/creates-action/SignUpAction';
import Color from '../color/Color';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function OtpModal() {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
  const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
  const data = useSelector((state) => state.otp.data);
  const [otp, setOtp] = useState('');
  const [phone, setPhone] = useState('');
  const [authenType, setAuthenType] = useState(null);
  const [time, setTime] = useState(180);
  const [wrong, setWrong] = useState(3);
  const dispatch = useDispatch();
  const data1 = useSelector((state) => state.signup.data.businessInfo);
  const data2 = useSelector((state) => state.signup.data.companyInfo);
  const data3 = useSelector((state) => state.signup.data.bankAccount);
  const data4 = useSelector((state) => state.signup.data.companyRep);

  const [errorSignUp, setErrorSignUp] = useState('');

  useEffect(() => {
    setPhone(data.phone);
  }, [data.phone]);

  useEffect(() => {
    setAuthenType(data.authenType);
  }, [data.authenType]);

  const handleVerify = (e) => {
    e.preventDefault();
    let feature = data.feature;
    switch (feature) {
      case 'SHOW_OTP_FORGOT':
        if (otp.length === 6) {
          const variables = {
            data: {
              phone: phone,
              code: otp,
            },
          };
          dispatch(openLoadingApi());
          verifyOtp(variables)
            .then((result) => {
              dispatch(closeLoadingApi());
              if (result !== null) {
                const data = {
                  phone: phone,
                };
                resetPasswordGraphql(data)
                  .then((result) => {
                    if (result !== null) {
                      dispatch(goToNextStep());
                      dispatch(closeOtpModal());
                      setOtp('');
                    }
                  })
                  .catch((error) => {
                    dispatch(closeLoadingApi());
                    dispatch(
                      getMessageOtp('Server error, please try again', 'error')
                    );
                    setOtp('');
                  });
              }
            })
            .catch((errors) => {
              let err = JSON.parse(JSON.stringify(errors, undefined, 2));
              if (err.response !== undefined) {
                if (
                  err.response.errors[0].message.indexOf(
                    'Incorrect Otp Value'
                  ) !== -1
                ) {
                  dispatch(closeLoadingApi());
                  dispatch(
                    getMessageOtp(
                      'Incorrect Otp Value, please try again',
                      'error'
                    )
                  );
                  setOtp('');
                }
              } else {
                dispatch(closeLoadingApi());
                dispatch(
                  getMessageOtp('Server error, please try again', 'error')
                );
                setOtp('');
              }
            });
        } else {
          alert('otp invalid');
          dispatch(closeLoadingApi());
        }
        break;
      case 'OTP_LOGIN':
        if (otp.length === 6) {
          const variables = {
            data: {
              phone: data.phone,
              code: otp,
            },
          };
          verifyOtp(variables)
            .then((result) => {
              if (result !== null) {
                dispatch(goToNextStep());
                dispatch(closeOtpModal());
                setOtp('');
              }
            })
            .catch((errors) => {
              let err = JSON.parse(JSON.stringify(errors, undefined, 2));
              if (err.response !== undefined) {
                if (
                  err.response.errors[0].message.indexOf(
                    'Incorrect Otp Value'
                  ) !== -1
                ) {
                  dispatch(
                    getMessageOtp(
                      'Incorrect Otp Value, please try again',
                      'error'
                    )
                  );
                  setOtp('');
                }
              } else {
                dispatch(
                  getMessageOtp('Server error, please try again', 'error')
                );
                setOtp('');
              }
            });
        } else {
          alert('otp invalid');
        }
        break;
      case 'OTP_SIGNUP':
        if (otp.length === 6) {
          const variables = {
            data: {
              phone: data.phone,
              code: otp,
            },
          };
          verifyOtpSignUp(variables)
            .then((result) => {
              if (result !== null) {
                dispatch(closeOtpModal());
                setOtp('');
                const data = {
                  data: {
                    brc_number: data1.company,
                    name: data1.legal,
                    type: data1.idType.toString(),
                    country: data2.idCountry,
                    brand: data2.idBrand,
                    industry: data2.idIndustry.toString(),
                    zip: data2.zipCode,
                    state: data2.idState,
                    city: data2.idCity,
                    address: data2.address,
                    phone: data2.phone,
                    email: data2.email,
                    bankID: data3.accountId,
                    e_nane: data4.fullName,
                    e_job: '',
                    e_phone: data4.phone,
                    e_email: data4.email,
                    e_address: data4.address,
                  },
                };
                createAllMerchant(data)
                  .then((result) => {
                    if (result !== null) {
                      dispatch(signUpSuccess());
                      dispatch(
                        finalStep(4, 'Create Merchant Successful!', 'success')
                      );
                    } else {
                      dispatch(closeOtpModal());
                      dispatch(
                        finalStep(
                          3,
                          'An error occurred, Please try later!',
                          'error'
                        )
                      );
                    }
                  })
                  .catch((e) => {
                    const response = JSON.parse(JSON.stringify(e));
                    const errors = response.response.errors;
                    let errorMessage = '';
                    errors.map((error) => {
                      errorMessage += error.message;
                      return error;
                    });
                    setErrorSignUp(errorMessage);
                    dispatch(finalStep(3, errorSignUp, 'error'));
                  });
              } else {
                dispatch(closeOtpModal());
                setOtp('');
              }
            })
            .catch((error) => {
              dispatch(finalStep(3, 'Incorrect Otp Value', 'error'));
              dispatch(closeOtpModal());
              setOtp('');
            });
        } else {
          alert('otp invalid');
        }
        break;

      default:
        break;
    }
  };

  const handleClose = () => {
    setOtp('');
    setWrong(3);
    setTime(180);
    dispatch(closeOtpModal());
  };

  const handleResend = () => { };

  const enterOtp = (event) => {
    var value = otp ? event : otp + event;
    setOtp(value);
  };

  useEffect(() => {
    if (wrong === 0) {
      setOtp('');
      setWrong(3);
      dispatch(closeOtpModal());
    }
  }, [wrong, dispatch]);

  const renderTimeRemainingCircle = (open, time) => {
    return open ? (
      <CountdownCircleTimer
        isPlaying={open}
        duration={time}
        colors={['#1976D2', '#F7B801', '#A30000', '#A30000']}
        colorsTime={[120, 60, 30, 0]}
        sx={{ fontSize: '12px' }}
        size={matchDownSM ? '60' : '80'}
        strokeWidth={matchDownSM ? '3' : '5'}
        onComplete={handleClose}
      >
        {({ remainingTime }) => remainingTime}
      </CountdownCircleTimer>
    ) : (
      <div></div>
    );
  };

  return (
    <Container maxWidth="sm">
      <Dialog
        onClose={handleClose}
        open={data.isOpen}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        style={{
          height: `${matchDownSM ? '90%' : '100%'}`,
          marginTop: `${matchDownSM ? '-100px' : '-100px'}`,
        }}
      >
        <Grid
          component="form"
          onSubmit={handleVerify}
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          direction="column"
          sx={{ p: `${matchDownSM ? '18px' : '20px'}` }}
        >
          {/* {process.env.REACT_APP_PRODUCT_TYPE === 'non-pro' && ( */}
            <>
              <Grid
                item xs={12}
                sx={{
                  fontFamily: "'Asap', normal",
                  fontWeight: 600,
                  color: '#FF0000',
                }}
              >
                In non production version
              </Grid>
              <Grid
                item xs={12}
                sx={{
                  fontFamily: "'Asap', normal",
                  fontWeight: 600,
                  color: '#FF0000'
                }}
              >
                You can enter any OTP code to verify!
              </Grid>
            </>
          {/* )} */}
          <Grid item xs={12}>
            <DialogTitle onClose={handleClose} variant="h4"
              style={{ color: Color.Main }}
            >
              Verify OTP
            </DialogTitle>
          </Grid>
          <Grid item sx={{ display: 'flex', textAlign: 'center' }}>
            {authenType === 2 ? (
              <DialogContentText sx={{ color: Color.Main }}>
                Enter 6-digit confirmation in your Google Authenticate App
              </DialogContentText>
            ) : (
              <DialogContentText sx={{ color: Color.Main }}>
                We've sent a 6-digit confirmation to{' '}
                <span style={{ color: '#1976d2' }}>{data.phone}</span>
              </DialogContentText>
            )}
          </Grid>
          <Grid item xs={12} sx={{ mb: '10px' }}>
            {renderTimeRemainingCircle(data.isOpen, time)}
          </Grid>
          <Grid item xs={12} sx={{ my: 3 }}>
            <OTPInput
              value={otp}
              onChange={enterOtp}
              autoFocus
              isInputNum
              numInputs={6}
              inputStyle={{
                border: '1px solid #999',
                borderRadius: '5px',
                width: `${matchDownMD ? '1.55rem' : '34px'}`,
                height: `${matchDownMD ? '1.55rem' : '34px'}`,
                marginLeft: `${matchDownMD ? '6px' : '12px'}`,
                marginRight: `${matchDownMD ? '6px' : '12px'}`,
                paddingLeft: '2px',
              }}
              type="number"
              disabled={false}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              size={matchDownSM ? 'small' : 'medium'}
              sx={{
                textAlign: 'center',
                maxWidth: '250px',
                fontSize: `${matchDownSM ? '12px' : '16px'}`,
                textTransform: 'capitalize',
              }}
              color="error"
              type="submit"
              onClick={handleVerify}
            >
              Validate OTP{' '}
            </Button>
          </Grid>
          <DialogContent
            sx={{
              p: `${matchDownSM ? '5px' : '20px'}`,
            }}
          >
            {authenType === 2 ? (
              <></>
            ) : (
              <DialogContentText
                id="alert-dialog-slide-description"
                sx={{ color: Color.Main }}
                fontSize={matchDownSM ? '12px' : '16px'}
              >
                Don't have receive SMS, click{' '}
                <span
                  style={{
                    color: '#1976d2',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                  onClick={handleResend}
                >
                  here
                </span>
              </DialogContentText>
            )}
          </DialogContent>
        </Grid>
      </Dialog>
    </Container>
  );
}
